module.exports = __webpack_public_path__ + "img/manhole-chart-top.ce223318.png";